<div class="reports-container">

  <div class="welcome-section mb-4 fade-in">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Reports</h2>
        <h4 class="welcome-text">Analyze your business's financial performance over time</h4>
      </div>
    </div>
  </div>
  <!-- Loading and Error States -->
  <div *ngIf="loading" class="loading">
    <div class="spinner"></div>
    <p>Loading report data...</p>
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>


  <!-- Profit/Loss Analysis Section -->
  <div class="profit-loss-analysis" *ngIf="!loading && !error">
    <div class="section-header">
      <h3>Profit/Loss Analysis</h3>
      <button class="btn-export" (click)="exportToPdf()">
        <i class="fas fa-file-pdf"></i> Export to PDF
      </button>
    </div>

    <!-- Summary Cards -->
    <div class="summary-cards">
      <div class="card money-in">
        <h3>Total Money In</h3>
        <div class="amount">{{ reportData.moneyIn | currency:'ZAR':'symbol':'1.0-0' }}</div>
      </div>
      <div class="card money-out">
        <h3>Total Money Out</h3>
        <div class="amount">{{ reportData.moneyOut | currency:'ZAR':'symbol':'1.0-0' }}</div>
      </div>
      <div class="card net-cash-flow" [class.positive]="reportData.netCashFlow >= 0" [class.negative]="reportData.netCashFlow < 0">
        <h3>Net Cash Flow</h3>
        <div class="amount">{{ reportData.netCashFlow | currency:'ZAR':'symbol':'1.0-0' }}</div>
        <div class="margin" *ngIf="reportData.moneyIn > 0">
          {{ (reportData.netCashFlow / reportData.moneyIn * 100) | number:'1.0-1' }}% of Income
        </div>
      </div>
    </div>

    <!-- Transaction Details -->
    <div class="transaction-details">
      <h4>Transaction Details</h4>
      <div class="table-responsive">
        <table class="transaction-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Reference</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of reportData.transactionDetails">
              <td>{{ tx.date | date:'shortDate' }}</td>
              <td>
                <div class="transaction-description">
                  <div class="transaction-type">{{ tx.transactionType }}</div>
                  <div class="item-details">
                    <span class="item-name">{{ tx.itemName }}</span>
                    <span class="item-number">#{{ tx.itemNumber }}</span>
                  </div>
                </div>
              </td>
              <td>
                <span class="badge" [class.badge-success]="tx.type === 'IN'" [class.badge-danger]="tx.type === 'OUT'">
                  {{ tx.type }}
                </span>
              </td>
              <td class="text-right" [class.text-success]="tx.type === 'IN'" [class.text-danger]="tx.type === 'OUT'">
                {{ tx.amount | currency:'ZAR':'symbol':'1.2-2' }}
              </td>
              <td>{{ tx.reference }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
